import { render } from "./AppHeader.vue?vue&type=template&id=2b6bc879&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=2b6bc879&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b6bc879"

export default script